import type { FC } from 'react';
import Button from '@components/Button';
import IconMdi from '@components/IconMdi';
import Tooltip from '@components/Tooltip';
import { getLockedBlockPermissionsMessage } from '@ContractBuilder/utils/get-locked-block-permissions-message';
import { mdiTrashCanOutline } from '@mdi/js';

import { useBlockPanelContent } from '../hooks/useBlockPanelContent';

import { DrawerCollapsibleGroup } from './DrawerCollapsibleGroup';

interface DrawerPanelActionsProps {
  canDeleteBlock: boolean;
  isBlockType: boolean;
  onDelete: () => void;
}

export const DrawerPanelActions: FC<DrawerPanelActionsProps> = ({ canDeleteBlock, isBlockType, onDelete }) => {
  const { getContent } = useBlockPanelContent(isBlockType);

  const lockedMessage = getLockedBlockPermissionsMessage(/* canEdit */ true, /* canDelete */ false);

  return (
    <DrawerCollapsibleGroup title={getContent('groups.actions')} id="actions" className="border-b">
      <>
        {canDeleteBlock ? (
          <Button kind="ghost" className="h-8 w-fit -translate-x-2.5 px-2 shadow-none" onClick={onDelete}>
            <IconMdi path={mdiTrashCanOutline} size={0.7} />
            {getContent('removeButton')}
          </Button>
        ) : (
          <Tooltip content={lockedMessage}>
            <span>
              <Button isDisabled kind="ghost" className="h-8 w-fit -translate-x-2.5 px-2 shadow-none">
                <IconMdi path={mdiTrashCanOutline} size={0.7} />
                {getContent('removeButton')}
              </Button>
            </span>
          </Tooltip>
        )}
      </>
    </DrawerCollapsibleGroup>
  );
};
